import { render, staticRenderFns } from "./freeze_log.vue?vue&type=template&id=1c1c1263&scoped=true&"
import script from "./freeze_log.vue?vue&type=script&lang=js&"
export * from "./freeze_log.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c1c1263",
  null
  
)

export default component.exports